import { light } from "@mui/material/styles/createPalette";

const config = {
  // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
  basename: "",
  defaultPath: "/app/home",
  defaultPathID: "",
  fontFamily: `'Inter', sans-serif`, //'Poppins', sans-serif
  fontSize: 16,
  backgroundColor: "#ffffff", //#fffbf6
  borderColor: "#E0E0E0", //ede6df
  brandColor: {
    primary: "#2A708C",
    secondary: "#2B7B8C",
    accent: "#89D1D9",
    light: "#F2F2F2",
    text: "#0D0D0D",
    accent2: "#a9edff",
  },
  borderRadius: 8,
  borderRadiusSmall: 6,
  gridSpacing: 3,
  gridSpacingSm: 2,
};

export default config;
